module.exports = __webpack_public_path__ + "media/images/emblems/Blason_Saillon-5197dc372f05431c8bd3dd0ab0b92c32.svg";